const e=e=>{if(e){const t=document.querySelector(e);return t?.offsetHeight??0}return 0};export{e as getHeaderHeight};
